// Table List Models
export interface TableListConfig {
  header: string;
  field: string;
  fieldType: FieldType;
  formatType?: FormatType;
  fuelFormatType?: FormatType;
  hidden?: boolean;
  outOfView?: boolean;
  style?: string;
  identifier?: boolean;
  dateFilter?: boolean;
  strikethroughZeros?: boolean;
  showCurrency?: boolean;
}

export enum FieldType {
  STRING = "string",
  NUMBER = "number",
  DATE = "date",
  DATE_TIME = "datetime",
  BOOLEAN = "boolean",
  OPTIONS = "options",
  PROGRESS = "progress",
  CHIP_STRING = "chip_string",
  CHIP_NUMBER = "chip_number",
  ICON = "icon",
  COLOR = "color",
  ARRAY = "array",
  IMAGE = "image",
  OBJECT = "object",
  OBJECT_DESCRIPTION = "object_description",
  COUNTRY = "country",
	CHECKBOX = "checkbox",
}

export enum PropertyDataTypeCode {
  TEXT = "TEXT",
  NUMERIC = "NUMERIC",
  DATE = "DATE",
  BOOLEAN = "BOOLEAN",
}

export enum FormatType {
  DATE = "dateFormat",
  TIME = "timeFormat",
  DATETIME = "datetimeFormat",
  AMOUNT = "amountFormat",
  CURRENCY = "currencyFormat",
  UNITPRICE = "unitPriceFormat",
  FUELUNITPRICE = "fuelUnitPriceFormat",
  UOM = "uomFormat",
  FUELUOM = "fuelUomFormat",
  PERCENT = "percentageFormat",
}

export enum DefaultPage {
  PAGE_INDEX = 0,
  PAGE_SIZE = 50,
  EXCEL_PAGE_SIZE = 100000,
}

export interface TableEvent extends ExportEvent {
  pageEvent: PageEvent;
}

export interface ExportEvent {
  pageEvent: PageEvent;
}

export interface PageEvent {
  pageIndex: number;
  pageSize: number;
}

export interface ColumnHidden {
  header: string;
  hidden: boolean;
}

export interface ColumnSorterInfo extends ColumnFilterInfo {
  hidden: boolean;
  pin: boolean;
  filtered?: boolean;
}

export interface ColumnFilterInfo {
  id: string;
  name: string;
}